export const Codes_Ttl_Seconds = 120;
// sync: resend-otp-v2
